import { render, staticRenderFns } from "./BannerListDialog.vue?vue&type=template&id=6cb4980f&scoped=true&"
import script from "./BannerListDialog.vue?vue&type=script&lang=js&"
export * from "./BannerListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb4980f",
  null
  
)

export default component.exports